'use strict';

/* global angular */

const _ = require('lodash');

/** @DataCaptureStore */
const DataCaptureStore = function (ResourceHelper, Flux, DataCaptureSelectorActions, APP_DISPATCHER_ID, AnalyticsService, $location, $state) {

  const DataCaptureResource = ResourceHelper.getResource('DataCapture');
  const SiteStore = Flux.Store.get('SiteStore');
  const MeasurementStore = Flux.Store.get('MeasurementStore');

  // Intialize the store
  const DataCaptureStore = Flux.Store.create({
    name: 'DataCaptureStore',
    events: {
      Changed: true
    }
  });

  /**
   * Initial empty store state
   * @var {object} $state
   */
  DataCaptureStore.$state = {
    current : null,
    available : null,
    processing: null
  };

  /**
   * Intialize the store bindings and initial data.
   * @constructor
   */
  DataCaptureStore.init = function () {
    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(DataCaptureSelectorActions.DataCaptureChanged, this._handleDataCaptureChange.bind(this));
  }.bind(this);

  /**
   * Sets the internal state for the Store (used by the Router logic to place the current DataCapture).
   * @param {object} [state] An DataCaptureStore state object.
   */
  DataCaptureStore.setState = (state) => {
    angular.extend(DataCaptureStore.$state, state);

    DataCaptureStore.emit(DataCaptureStore.Events.Changed);
  };

  DataCaptureStore.getRelations = (id) => {
    return DataCaptureResource.find(id, {
      bypassCache: true,
      params: { include: 'dataExports' },
      linkInverse: false
    });
  };

  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handler for fetching the current datacaptures available for the current selected Site
   * and make it available on the $state
   */
  this._handleSiteStoreChange = () => {
    const currentSite = SiteStore.get('current');

    // null current site do nothing then?
    if (!currentSite) {
      return;
    }

    DataCaptureStore.setState({
      available: currentSite.dataCaptures,
      timezoneId: SiteStore.get('timezoneId'),
      timezoneOffset: SiteStore.get('timezoneOffset')
    });

  };

  // Since `get('current')` returns a copy of the Resource without its methods,
  // encapsulate the method here and access $state directly
  DataCaptureStore.canRequestMeasurements = () => {
    if (DataCaptureStore.$state.current) {
      return DataCaptureStore.$state.current.canRequestMeasurements();
    }
    return false;
  };

  /**
   * Handler for the select datacapture action (triggered by the DataCaptureSelectorStore)
   * @param {object} [event] An object containing the selected datacapture in the data index
   */
  this._handleDataCaptureChange = (ev) => {
    
    var datacapture = ev.data.newDataCapture;
    var current = DataCaptureStore.get('current');

    if (datacapture.id){
      /* TODO: doesn't track datacapture that loads on initial app loading */
      AnalyticsService.track('[CORE] Data Captures', 'View Data Capture', {
        dataCaptureId: datacapture.id,
        siteId: datacapture.siteId,
        siteName: datacapture.site.name
      });
      if (!current || current.id !== datacapture.id) {
        MeasurementStore.deactivateAll();
      }
      DataCaptureStore.$set('current', ev.data.newDataCapture);
      DataCaptureStore.emit(DataCaptureStore.Events.Changed);
    }
  };

  this._handleMeasurementStoreChange = () => {
    var MeasurementStore = Flux.Store.get('MeasurementStore');
    var currentMeasurements = MeasurementStore.get('current');
    if (currentMeasurements && currentMeasurements.length) {
      // Measurement store will always validate that only measurements from the same
      // date are active at once
      var dcId = currentMeasurements[0].dataCaptureId;
      var current = DataCaptureStore.get('current');
      if (dcId && (!current || current.id !== dcId)) {
        current = _.find(DataCaptureStore.get('available'), { 'id': dcId });
        if (current) {
          DataCaptureStore.setState({
            current: current
          });
        }
        else {
          console.warn('Datacapture for selected volume does not exist!');
        }
      }
    }
  };

  /**
   * This method is a workaround for the URL rewrite when changing dcs without
   * having to re-render the whole state, this is made by passing the `notify`
   * setting as well as the `urlUpdate` parameter as true.
   * Make sure that this only happens when the user is on the map state but not
   * on the current datacapture
   **/
  this._handleDatacaptureUrlRewrite = () => {
    var current = DataCaptureStore.get('current');
    if (!current) {
      return;
    }
    var url = $location.url();
    var site = SiteStore.get('current');

    var userIsInSite = url.match(new RegExp(_.escapeRegExp('/site/' + site.slug)));
    var userIsInDataCapture = url.match(new RegExp(_.escapeRegExp('/dc/' + current.id)));
    if (userIsInSite && !userIsInDataCapture) {
      var newLocation = 'site/' + SiteStore.get('current').slug + '/dc/' + current.id;
      $state.transitionTo('dash.map',
        {
          siteName : null,
          dataCaptureId : null,
          changeToLocation : newLocation,
          urlUpdate: true
        }, {
          location: true,
          notify: false
        }
      );
    }
  };

  // Bind for current site change, and fetch new datacaps
  SiteStore.on(SiteStore.Events.Changed, this._handleSiteStoreChange.bind(this));
  MeasurementStore.on(MeasurementStore.Events.Changed, this._handleMeasurementStoreChange.bind(this));

  // Hook the event for changing the url on the store itself
  DataCaptureStore.on(DataCaptureStore.Events.Changed, this._handleDatacaptureUrlRewrite.bind(this));

  return DataCaptureStore;
};

DataCaptureStore.$inject = ['ResourceHelper', 'sbFlux', 'DataCaptureSelectorActions', 'APP_DISPATCHER_ID', 'AnalyticsService', '$location', '$state'];
module.exports = DataCaptureStore;



// WEBPACK FOOTER //
// ./src/app/dash/dataStores/DataCaptureStore.js